module.exports = __webpack_public_path__ + "static/theleanfounder_logo-dc7780d5644ccf9ca028467f47c98c60.png";